import React from 'react';
import {Route, Switch, withRouter} from 'react-router-dom';
import {connect} from 'react-redux';

import Sidebar from './SideNav/index';
import Footer from '../components/Footer/index';
import Tour from '../components/Tour/index';
import {
  ABOVE_THE_HEADER,
  BELOW_THE_HEADER,
  COLLAPSED_DRAWER,
  FIXED_DRAWER,
  HORIZONTAL_NAVIGATION,
} from '../constants/ActionTypes';
// import ColorOption from 'containers/Customizer/ColorOption';
import {isIOS, isMobile} from 'react-device-detect';
import TopNav from '../components/TopNav/index';
import Header from '../components/Header/index';
import {setDarkTheme, setThemeColor} from '../actions/index';

import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { createIcon, RequestConfig, Notification, Scroller, runtime, BAProvider } from 'codeArt/common';
import { DARK_INDIGO } from '../constants/ThemeColors';
import Base64  from 'base-64';
import Backdrop from 'codeArt/components/Backdrop';
import { unKeepCache } from '../Root';
import { Util, StateProvider,ProxyProvider } from '../../common';
import { Principal } from 'codeArt/auth';
import { Tester } from 'codeArt/test';

class _App extends React.Component {

  constructor(props) {
    super(props);
    this.state={
      loading:true
    }
    App.current = this; //同一时间，只有一个App实例
    this.keepIds=[];
    this.history=new History();
  }

  themeColor(colorCode){
    this.props.setThemeColor(colorCode);
    const body = document.body.classList;
    body.remove(this.props.themeColor);
    body.remove('dark-theme');
    body.add(colorCode);
  };

  darkTheme(){
    this.props.setDarkTheme();
    const body = document.body.classList;
    body.toggle(this.props.themeColor);
    body.toggle('dark-theme');
  };


  componentWillMount() {
    this.themeColor(this.props.color);
  }

  componentDidMount(){
    this.init();

    //this.popstateRef = this.popstate.bind(this);
    //window.addEventListener('popstate', this.popstateRef);
  }

  componentWillUnmount(){
    this.dispose();
  }

  name(){
    return this.props.name;
  }

  // popstate(e){
  //   let s = e.state;
  //   let h = window.history;
  //   if(s.state === null){ //回退
  //     this.history.pop(); //将历史退一个
  //     if(this.history.items().length==0){  //只所以会是0，是因为用户刷新了页面，浏览器还是有历史的，还是让退回的，所以这里要补充一个push
  //       this.history.push(); //将当前路径压入
  //     }
  //   }else{  //前进
  //     this.history.push();
  //   }

  //   let items = this.history.items();
  // }

  initScrollerTimes=0;

  initScroller(){
    let my=this;
    if(my.initScrollerTimes > 100) throw Error("宿主滚动条初始化失败");  //超过10次还不能初始化，那么提示错误，并放弃
    my.initScrollerTimes++;
    setTimeout(()=>{  //不知道为什么找不到dom，所以延迟后初始化
      if(Scroller.init()){
        my.initScrollerTimes=0;//初始化成功后，归位
        return;
      }
      //如果不成功，继续初始化
      my.initScroller();
    },50);
  }

  init(){
    this.setRequestConfig();
    Tester.init(this);

    let {init,expand} = this.props;
    if(expand){
      for(let e in expand){
        this[e] = expand[e];
      }
    }

    if(init) init(()=>{
      this.setState({loading:false},()=>{
        this.initScroller();
      });
    });
    else{
      this.setState({loading:false},()=>{
        this.initScroller();
      });
    }
  }

  dispose(){
    Tester.dispose();
    this.clearKeep(true);
    //unKeepCache();//清空所有缓存
    Scroller.dispose();
  }

  setRequestConfig(){
    RequestConfig.init = (p) => {
      let auth = Principal.getAuth() 
                  || Principal.getAuth("extra"); //如果当前域没有授权信息，那么使用extra域的授权信息，避免切换域的时候，获取不到token
      if(auth){
        p.headers = p.headers||{};
        
        let token = auth.Token;
        if(token) p.headers["c-token"] = token;
        p.headers["c-language"] = "zh-CN";  //目前语言选项就一个，中文
      }
    }
    RequestConfig.before = (p) => {
      Backdrop.current.show();
    }
    RequestConfig.complete = () => {
      Backdrop.current.hide();
    }
    RequestConfig.error = (msg) => {
      Notification.error(msg);
    }
  
    RequestConfig.ioc = {  //所有的请求，都会走注入，
      error:(msg,p)=>{
        if(msg==="authError") {
          if(p.authError){
            //执行自定义授权错误的处理逻辑
            p.authError();
          }
          else{
            Principal.signOut();
            App.current.go("signin");
          }
          return false; //当返回false，表示阻止后续工作
        }
      }
    }
  }

      
  go(name,params,onBack){
    if(!params){
      this.props.history.push({
        pathname: name
      });
    }else{
      let code = App.getParamsCode(params);
      this.props.history.push({
          pathname: `${name}/${code}`
      });
    }
    this.history.push({name,params,onBack});
  }

  replace(name,params){
    if(!params){
      this.props.history.replace({
        pathname: name
      });
    }else{
      let code = App.getParamsCode(params);
      this.props.history.replace({
          pathname: `${name}/${code}`
      });
    }
  }

  back(){
    this.props.history.goBack();
    let arg = this.history.pop();
    if(arg && arg.onBack) arg.onBack();
  }


  //historyPop(item){
    // let keeps = item.keeps;
    // if(keeps){
    //   keeps.forEach((keepId)=>{
    //     unKeepCache(keepId);
    //   });
    // }
  //}

  registerKeep(keepId){
    let keepIds = this.keepIds;
    if(keepIds.indexOf(keepId) == -1) keepIds.push(keepId);
  }

  clearKeep(v,exclude){
    if(exclude && Util.type(exclude) !== "array") exclude=[exclude];
    if(v===true){ //移除除了指定的exclude以外的所有保留
        if(exclude){
            for(var i=0;i<this.keepIds.length;i++){
              var keepId = this.keepIds[i];
              if(exclude.indexOf(keepId)>-1) continue;
              unKeepCache(keepId);
              Scroller.remove(keepId);
              StateProvider.remove(keepId);
              ProxyProvider.remove(keepId);
              BAProvider.remove(keepId);
            }
            this.keepIds=[...exclude];
        }
        else{
          unKeepCache();
          this.keepIds=[];
          Scroller.clear();
          StateProvider.clear();
          ProxyProvider.clear();
          BAProvider.clear();
        }        
    }else{
      //移除指定集合v的,但排除exclude以外的保留
      if(Util.type(v) !== "array") v=[v];
      if(exclude){
        var my = this;
        v.forEach((keepId)=>{
          if(exclude.indexOf(keepId)>-1) return;
          unKeepCache(keepId);
          Scroller.remove(keepId);
          StateProvider.remove(keepId);
          ProxyProvider.remove(keepId);
          BAProvider.remove(keepId);
          Util.remove(my.keepIds,(t)=>{
            return t==keepId;
          });
        });
      }
      else{
        var my = this;
        v.forEach((keepId)=>{
          unKeepCache(keepId);
          Scroller.remove(keepId);
          StateProvider.remove(keepId);
          ProxyProvider.remove(keepId);
          BAProvider.remove(keepId);
          Util.remove(my.keepIds,(t)=>{
            return t==keepId;
          });
        });
      } 
    }
  }


  header(){
    const { navigationStyle, horizontalNavPosition,showHeader,header,quick,toolbar} = this.props;
    if(showHeader ===false) return null;
    if(header&&header.hidden) return null;
    return (
        <div
            className={`app-header ${navigationStyle === HORIZONTAL_NAVIGATION ? 'app-header-horizontal' : ''}`}>
            {(navigationStyle === HORIZONTAL_NAVIGATION && horizontalNavPosition === ABOVE_THE_HEADER) &&
            <TopNav styleName="app-top-header"/>}
            <Header quick={quick} toolbar={toolbar} />
            {(navigationStyle === HORIZONTAL_NAVIGATION && horizontalNavPosition === BELOW_THE_HEADER) &&
            <TopNav/>}
          </div>
    );
  }

  footer(){
    return null;//不再显示页脚
    // const { footer} = this.props;
    // if(footer&&footer.hidden) return null;
    // return <Footer/>;
  }

  render() {
    if(this.state.loading) return null;

    const {match, drawerType, menus,passage,history,layout,sidebar,header,title} = this.props;
    const drawerStyle = drawerType.includes(FIXED_DRAWER) ? 'fixed-drawer' : drawerType.includes(COLLAPSED_DRAWER) ? 'collapsible-drawer' : 'mini-drawer';

    //set default height and overflow for iOS mobile Safari 10+ support.
    if (isIOS && isMobile) {
      document.body.classList.add('ios-mobile-view-height')
    }
    else if (document.body.classList.contains('ios-mobile-view-height')) {
      document.body.classList.remove('ios-mobile-view-height')
    }

    if(layout=="slim"){
      return (
        <div className={`app-container`}>
          <div className="app-main-container">
            <main id="app-main-content" className="app-main-content-wrapper">
              <div className="app-main-content">
                  {this.props.children}
              </div>
            </main>
          </div>
        </div>
      )
    }

    if(runtime.pc && layout=="narrow"){
      return (
        <div className={`app-container app-container-narrow`}>
          <div className="app-main-container">
            {this.header()}
            <main id="app-main-content" className="app-main-content-wrapper">
              <div className="d-flex flex-row mx-auto c-container-narrow">
                {sidebar===false?null:<Sidebar menus={menus} passage={passage} history={history} />}
                <div className="app-main-content">
                    {this.props.children}
                </div>
              </div>
            </main>
          </div>
        </div>
      )
    }

    return (
      <div className={`app-container ${drawerStyle}`}>
        {/* <Tour/> */}
        {sidebar===false?null:<Sidebar title={title} menus={menus} passage={passage} history={history} />}
        <div className="app-main-container">
          {this.header()}
          <main id="app-main-content" className="app-main-content-wrapper">
            <div className="app-main-content">
                {this.props.children}
            </div>
            {this.footer()}
          </main>
        </div>
      </div>
    );
  }
}

_App.defaultProps={
    color:DARK_INDIGO
}


const mapStateToProps = ({settings}) => {
  const {drawerType, navigationStyle, horizontalNavPosition,themeColor,header,footer} = settings;
  return {drawerType, navigationStyle, horizontalNavPosition,themeColor,header,footer}
};


const App = withRouter(connect(mapStateToProps,{setThemeColor, setDarkTheme})(_App));

App.getParamsCode = (params)=>{
  let code = JSON.stringify(params);
  return Base64.encode(escape(code));//这个库的Base64.encode不支持汉字，所以escape 一下
}

export default App;



function History() {

  let items=[];

  this.push=(arg)=>{
    items.push(arg);
  }

  this.pop=()=>{
    return items.pop();
  }

  this.current=()=>{
    return items[items.length-1];
  }

  this.items=()=>{
    return items;
  }

  this.length=()=>{
    return items.length;
  }

}



// function History({onPop}) {

//   let items=[];

//   let init = ()=>{
//     this.push();
//   }


//   this.push=(path)=>{
//     path = path || window.location.pathname;
//     items.push({path,keeps:[]});
//   }

//   this.pop=(path)=>{

//     if(path){ //弹出到path就不弹了
//       var index = Util.indexOf(items,(item)=>{
//         return item.path == path;
//       });

//       if(index > -1){
//         let pops = items.slice(index+1);
//         items = items.slice(0,index+1);

//         pops.forEach((item)=>{
//           onPop(item);
//         });

//         return true;
//       }
//       return false;
//     }

//     let last = items.pop();
//     if(last) onPop(last);
//   }

//   this.current=()=>{
//     return items[items.length-1];
//   }

//   this.items=()=>{
//     return items;
//   }

//   this.get=(path)=>{
//     return Util.first(items,(item)=>{
//       return item.path == path;
//     });
//   }

//   init();

// }


export class PassageSlim extends React.Component {

  state = {
    anchorEl: null,
    open: false,
  };

  open = event => {
    this.setState({open: true, anchorEl: event.currentTarget});
  };

  handleRequestClose = () => {
    this.setState({open: false});
  };

  render() {
    let {items}=this.props;
    return (
      <Menu className="user-info"
              anchorEl={this.state.anchorEl}
              open={this.state.open}
              onClose={this.handleRequestClose}
              PaperProps={{
                style: {
                  minWidth: 120,
                  paddingTop: 0,
                  paddingBottom: 0
                }
              }}
        >
          {
            items.map(({label,icon,click},i)=>{
              icon = createIcon(icon,"zmdi-hc-fw mr-2");
              return <MenuItem key={i} onClick={() => {
                        this.handleRequestClose();
                        click()
                      }}>
                      {icon}
                      {label}
                    </MenuItem>
            })
          }
        </Menu>
    );
  }
}

PassageSlim.defaultProps={
}


